import { AttestationOption, AttestationForRequest } from '@sdk/automatedBreaks/types/Attestation';

export const mapAttestationUItoAPI = (
  attestationUI: AttestationForRequest
): AttestationForRequest => {
  const attestationApi: AttestationForRequest = {
    breakType: attestationUI.breakType,
    breakNumber: attestationUI.breakNumber,
    option: attestationUI.option
  };

  if (attestationUI.option === AttestationOption.prevented && attestationUI.text) {
    attestationApi.text = attestationUI.text;
  }

  return attestationApi;
};
